enum ListingStatus {
    Archived = 'archived',
    Open = 'available',
    Closed = 'closed'
}

export default ListingStatus
